
import { defineComponent } from "vue";
import api, { ReceiverArchiveList, ReceiverArchive, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: ReceiverArchiveList;
  requestFilter: ReceiverArchive;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "ReceiverEventArchive",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const archive_list = { count: 0 } as ReceiverArchiveList;
    const archive_struct = { } as ReceiverArchive;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {};
    return {
      msg: "Event Archives",
      backendResponse: archive_list,
      requestFilter: archive_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    deleteArchive(id: string) {
      api.deleteReceiverArchive(id).then(() => {
        this.$router.go(0)
      });
    },
    getDownload(id: string) {
      api.getReceiverArchive(id).then(response => {
        const blob = new Blob([JSON.stringify(response.data)], { type: 'text/json' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'ReceiverEventArchive-' + id + '.json'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as ReceiverArchive;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse.items = [];
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getReceiverArchiveList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
